import { render, staticRenderFns } from "./FormSessionDialogWrap.vue?vue&type=template&id=4a36d4e0&scoped=true&"
import script from "./FormSessionDialogWrap.vue?vue&type=script&lang=ts&"
export * from "./FormSessionDialogWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormSessionDialogWrap.vue?vue&type=style&index=0&id=4a36d4e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36d4e0",
  null
  
)

export default component.exports